import React from 'react';

import { ReactProps } from '../../../typings/common-types';

import Icon, { IIcon } from './icon';

const svg = (props: ReactProps) => (
  <svg viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg" fill="currentColor" {...props}>
    <path d="M14.98 12.98a.612.612 0 01.864 0l3.824 3.823.06.068c.1.135.137.302.111.461l.008-.097a.614.614 0 01-.18.433l.06-.07a.615.615 0 01-.072.083l-3.81 3.81-.07.06a.612.612 0 01-.796-.06l-.06-.068a.612.612 0 01.06-.797l2.779-2.78-9.229.001a.612.612 0 01-.076-1.219l.076-.004 9.229-.001-2.779-2.779-.06-.068a.612.612 0 01.06-.797zm-2.96-7.648a.612.612 0 01.06.797l-.06.068-2.78 2.779h9.995a.612.612 0 01.077 1.22l-.077.004H9.241l2.78 2.78a.612.612 0 01.06.796l-.06.068a.612.612 0 01-.797.06l-.068-.06-3.824-3.823a.612.612 0 01-.06-.797l.06-.068 3.824-3.824a.612.612 0 01.865 0z" />
  </svg>
);

const IconSubstitution = (props: IIcon & ReactProps) => <Icon {...props} svg={svg} />;

export default IconSubstitution;
